import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Invoice, InvoiceInfo } from 'app/admin/invoices/invoice.models';

@Component({
  selector: 'app-invoice-small-card',
  templateUrl: './invoice-small-card.component.html',
  styleUrls: ['./invoice-small-card.component.scss']
})
export class InvoiceSmallCardComponent implements OnInit {
  @Input() item: Invoice;
  @Input() companyList = [];
  @Input() invoiceTypes: InvoiceInfo[] = [];
  @Output() onTypeChangeSelect = new EventEmitter<InvoiceInfo>();
  @Output() handleCompanyAutocomplete = new EventEmitter<{ selectedItem: any, item: Invoice}>();
  @Output() uploadInvoice = new EventEmitter();

  constructor(public translate: TranslateService) { }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /app/src/app/client/invoices/invoice-small-card/invoice-small-card.component.ts